import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import SuccessIcon from '../Icons/SuccessIcon';

interface Props {
  toggle(): void;
  filename: string;
}

const SuccessDeactivationTeam: React.FC<Props> = ({ toggle, filename }) => {
  const { t } = useTranslation(['includeTeam']);
  const navigate = useNavigate();

  function redirectToHistory() {
    navigate(`?p=historico-importacoes&active=desativacao&filename=${filename}`);
  }

  return (
    <div className="success-wrapper" data-testid="success-many-modal">
      <div className="icon-wrapper">
        <SuccessIcon />
      </div>
      <span className="title-success">{t('modalBeneficiariesDeactivation:file_success_title')}</span>
      <span className="subtitle">{t('modalBeneficiariesDeactivation:ongoing')}</span>
      <span className="subtitle-two">
        {t('modalBeneficiariesDeactivation:file_success_text')} <strong>{filename}</strong>
      </span>
      <div className="deactive-button-container">
        <span className="new-file" onClick={toggle}>
          {t('modalBeneficiariesDeactivation:deactive_other_team')}
        </span>
        <button type="button" className="ok-button deactivate" onClick={redirectToHistory} style={{ marginLeft: 16 }}>
          {t('modalBeneficiariesDeactivation:track_status')}
        </button>
      </div>
    </div>
  );
};

export default SuccessDeactivationTeam;
